"use strict";
import { jsx, jsxs } from "react/jsx-runtime";
import classNames from "classnames";
const types = {
  info: {
    iconClass: "icon-info",
    alertClass: "alert-box--highlight"
  }
};
export default function Notification(props) {
  const typeDetails = types[props.type || "info"] || types["info"];
  const alertClasses = classNames({
    [typeDetails.alertClass]: true,
    "alert-box--flex": true,
    "mb-1": true
  });
  const iconClasses = classNames({
    icon: true,
    [typeDetails.iconClass]: true,
    "icon--no-repeat": true,
    "icon--sm": true,
    "mr-2": true
  });
  return /* @__PURE__ */ jsxs("div", { className: alertClasses, "data-component": "Notification", children: [
    /* @__PURE__ */ jsxs("div", { children: [
      /* @__PURE__ */ jsx("span", { className: iconClasses }),
      /* @__PURE__ */ jsx("span", { className: "mr-2", children: /* @__PURE__ */ jsx("strong", { children: props.title }) }),
      /* @__PURE__ */ jsx("span", { children: props.body })
    ] }),
    props.action && /* @__PURE__ */ jsx("div", { children: props.action })
  ] });
}
